import LoginModel                 from "./login-model";
import LoginPageView              from "./login-page-view";
import Translator                 from 'bazinga-translator';
import Axios                      from "../commun/axiosInstance";
import ResetExtranetPasswordModel from "./reset-extranet-password-model";
import ResetExtranetPasswordView  from "./reset-extranet-password-view";


export function initLoginViewModel({modelData, translationUrl})
{
    Axios.get(translationUrl).then((reponse) => {
        Translator.fromJSON(reponse.data);
        const $el = $('div#loginbox');

        const model = new LoginModel(modelData);
        const view =  new LoginPageView({ model, el: $el });
        view.render();
    });
}

export function initResetExtranetPasswordViewModel({modelData})
{
    const $el = $('div#loginbox');

    const model = new ResetExtranetPasswordModel(modelData);
    const view =  new ResetExtranetPasswordView({ model, el: $el });
    view.render();
}